import { plainMurnAddressFromFormkit, plainMurnAddressToFormkit } from "@modernary/mui/components/fk";

import type { AsbestosFacility, AsbestosFacilityNew } from "@/views/asbestosFacility/asbestosFacility";
import { fillAddressLookupValues, getLookupByMurn, getLookupDescription } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: AsbestosFacility) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result = {} as AsbestosFacility; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: AsbestosFacility }) {
  await fillAddressLookupValues(response.data);

  addAuthRequestFields(response.data);

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: AsbestosFacility }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: AsbestosFacility) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends AsbestosFacility | AsbestosFacilityNew>(data: T) {
  plainMurnAddressToFormkit(data);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: AsbestosFacility) {
  plainMurnAddressFromFormkit(data as AsbestosFacility);
}
